import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appRemoveCurrencyFormatting]'
})
export class RemoveCurrencyFormattingDirective {

  constructor(private el: ElementRef) {}

  @HostListener('focus') onFocus() {
    const value = this.el.nativeElement.value;
    // Remove all non-numeric characters except for the decimal and minus sign
    if (value) {
      this.el.nativeElement.value = value.toString().replace(/[^0-9.-]+/g, '');
    }
  }

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const input = this.el.nativeElement;
    const cleanedValue = input.value.replace(/[^0-9.-]+/g, '');

    // If the cleaned value doesn't match the input, update the input's value
    if (cleanedValue !== input.value) {
      input.value = cleanedValue;
      event.preventDefault(); // Prevent invalid characters
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    // Prevent `$` symbol from being typed
    if (event.key === '$') {
      event.preventDefault();
    }
  }
}